import React from 'react';
import { TrendingUp, TrendingDown, Minus } from 'lucide-react';
import { ResponsiveContainer, AreaChart, Area, Tooltip } from 'recharts';
import './AdminStatCard.css';

const AdminStatCard = ({ label, value, change, trend, icon: Icon, color, formatValue }) => {
    const isPositive = (change || 0) > 0;
    const isNegative = (change || 0) < 0;
    const safeValue = value || 0;
    const displayValue = formatValue ? formatValue(safeValue) : safeValue.toLocaleString();

    return (
        <div className="admin-stat-card">
            <div className="stat-main">
                <div className="stat-header">
                    <div className="stat-icon-wrapper" style={{ backgroundColor: `${color}22`, color }}>
                        <Icon size={20} />
                    </div>
                    <div className="stat-change">
                        {isPositive && <span className="change-tag positive"><TrendingUp size={12} /> {change.toFixed(1)}%</span>}
                        {isNegative && <span className="change-tag negative"><TrendingDown size={12} /> {Math.abs(change).toFixed(1)}%</span>}
                        {!isPositive && !isNegative && <span className="change-tag neutral"><Minus size={12} /> 0%</span>}
                    </div>
                </div>

                <div className="stat-body">
                    <span className="stat-value">{displayValue}</span>
                    <span className="stat-label">{label}</span>
                </div>
            </div>

            <div className="stat-chart">
                <ResponsiveContainer width="100%" height={45}>
                    <AreaChart data={trend}>
                        <defs>
                            <linearGradient id={`gradient-${label}`} x1="0" y1="0" x2="0" y2="1">
                                <stop offset="5%" stopColor={color} stopOpacity={0.3} />
                                <stop offset="95%" stopColor={color} stopOpacity={0} />
                            </linearGradient>
                        </defs>
                        <Tooltip 
                            content={({ active, payload }) => {
                                if (active && payload && payload.length) {
                                    const data = payload[0].payload;
                                    return (
                                        <div className="chart-tooltip">
                                            <div className="tooltip-date">{data.date}</div>
                                            <div className="tooltip-value">{payload[0].value}</div>
                                        </div>
                                    );
                                }
                                return null;
                            }}
                        />
                        <Area
                            type="monotone"
                            dataKey="value"
                            stroke={color}
                            strokeWidth={2}
                            fillOpacity={1}
                            fill={`url(#gradient-${label})`}
                        />
                    </AreaChart>
                </ResponsiveContainer>
            </div>
        </div>
    );
};

export default AdminStatCard;
